/*
This source is part of the Akeria  and is
copyrighted by Uniphore system software limited.
All rights reserved.  No part of this work may be reproduced, stored in a
retrieval system, adopted or transmitted in any form or by any means,
electronic, mechanical, photographic, graphic, optic recording or otherwise,
translated in any language or computer language, without the prior written
permission of  Uniphore system software limited.
Uniphore system software limited.
Vaishnavi Silicon Terrace, B- Block, 
3rd & 4th floor, Hosur Rd, 
Adugodi, Bengaluru, Karnataka 560095
India
Copyright 2019 Uniphore system software limited.
Modification History
Date          Version                    Author                        Description
----------   -----------          --------------- ----------------     ------------------------
28-11-2019    Build 01             Gokulakannan                        For Input feild validation for without space
*/

import { Directive, ElementRef, Input, HostListener } from '@angular/core';


@Directive({
    selector: '[avoidSpace]',
})


export class AvoidspaceDirective {
    @Input("avoidSpace") mystyle: any;
    constructor(private el: ElementRef) {
      el.nativeElement.onkeypress = function (e) {
          if (String.fromCharCode(e.keyCode).match(/[^A-Za-z0-9]/g)) {
              e.preventDefault();
              return;
            }
      };
    }

}
